module.exports = __webpack_public_path__ + "img/img0.3c2c0d32.jpg";